import Immutable, { List } from 'immutable';

export type ProjectDriveItemType = 'File' | 'Folder';

export type ProjectDriveId = string;

interface ProjectDriveSource {
  itemId: string;
  itemType: ProjectDriveItemType;
}

export interface RawProjectDrive {
  driveId: string;
  projectId: string;
  name: string;
  ownerId: string;
  connectionId: string;
  providerType: string;
  connectionPrincipal: string;
  sources: ProjectDriveSource[];
}

export interface ProjectDriveData {
  driveId: string;
  projectId: string;
  name: string;
  ownerId: string;
  connectionId: string;
  providerType: string;
  connectionPrincipal: string;
  sources: List<ProjectDriveSource>;
}

const defaultValues: ProjectDriveData = {
  driveId: '',
  projectId: '',
  name: '',
  ownerId: '',
  connectionId: '',
  providerType: '',
  connectionPrincipal: '',
  sources: List<ProjectDriveSource>(),
};

export const ProjectDriveFactory = Immutable.Record(
  defaultValues,
  'ProjectDrive'
);

export class ProjectDrive extends ProjectDriveFactory {
  static deserialize(rawProjectDrive: RawProjectDrive): ProjectDrive {
    const { sources } = rawProjectDrive;

    return new ProjectDrive({
      ...rawProjectDrive,
      sources: List(sources),
    });
  }

  serialize(): RawProjectDrive {
    return this.toJS();
  }
}
